import { render, staticRenderFns } from "./BlytzLogo.vue?vue&type=template&id=ace38982&scoped=true"
var script = {}
import style0 from "./BlytzLogo.vue?vue&type=style&index=0&id=ace38982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace38982",
  null
  
)

export default component.exports